import React from 'react';
import cx from 'classnames';

import './style.scss';

const Badge = ({ text, color }) => {
  const styleName = cx({
    badge: true,
    [color]: Boolean(color),
  });

  return (
    <span styleName={styleName}>
      {text}
    </span>
  );
};

export default Badge;
